import { defaultTheme } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'

interface Props {
  handlerWithoutDocsModal: () => void
  handlerAddDocsModal: () => void
}

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  @media (max-width: ${defaultTheme.queries.mobile}) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px 0;
  }
`
const StyledBtn = styled(AButton)`
  width: 100%;
`

export const DealDocumentRequestControls: FC<Props> = ({ handlerWithoutDocsModal, handlerAddDocsModal }) => {
  const { t } = useTranslation('deal')
  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  return (
    <ButtonsWrapper>
      <StyledBtn
        size={isMobile ? 'largeMobile' : 'medium'}
        onClick={handlerWithoutDocsModal}
        id="withoutDocs"
        color="primary"
      >
        {t('requestDocumentsBlock.withoutDocs')}
      </StyledBtn>

      <StyledBtn
        size={isMobile ? 'largeMobile' : 'medium'}
        onClick={handlerAddDocsModal}
        id="requestDocuments"
        color="primary"
      >
        {t('requestDocumentsBlock.button')}
      </StyledBtn>
    </ButtonsWrapper>
  )
}
